/*
configurează Pinia (store-ul oficial pentru Vue 3) 
ca să păstreze starea aplicației între refresh-uri, 
dar nu doar în localStorage, ci folosind localforage

mai mult de 5MB!

Asta face ca orice store Pinia cu persist: true 
să fie salvat/reîncărcat din IndexedDB prin localforage, 
deci starea se păstrează și după ce închizi browserul, 
cu mai multă flexibilitate decât localStorage.
*/

import { createPinia } from 'pinia'
import { createPersistedStatePlugin } from 'pinia-plugin-persistedstate-2'
import localforage from 'localforage'

const pinia = createPinia()

// const piniaPlugin = createPersistedStatePlugin({
//   storage: {
//     getItem: async (key) => await localforage.getItem(key),
//     setItem: async (key, value) => await localforage.setItem(key, value),
//     removeItem: async (key) => await localforage.removeItem(key),
//   },
// })

const piniaPlugin = createPersistedStatePlugin({
  storage: {
    async setItem(key, value) {
      // safe clone la scriere
      const safe = JSON.parse(JSON.stringify(value))
      //console.log('🏪👉💾',key, safe)
      await localforage.setItem(key, safe)
    },
    async getItem(key) {
      return await localforage.getItem(key)
    },
    async removeItem(key) {
      await localforage.removeItem(key)
    },
  },
})

pinia.use(piniaPlugin)

export default pinia
